export const SELECT_CHILD = (state, payload = {}) => {
    state.selectedChild = payload;
};
